import type {
  CreateResult,
  DeleteResult,
  GetResult,
  ListResult,
  ServiceContext,
  UpdateResult,
} from "@prolarus/shared";
import { tryCreate, tryDelete, tryGet, tryList, tryUpdate } from "./_shared";

export interface GroupRow {
  id: string;
  company_id: string;
  name: string;
  description: string | null;
  is_active: boolean;
  created: string;
  modified: string;
  created_by: string | null;
  updated_by: string | null;
}

// Mirrors the prior groupService. The unused params are kept for signature
// compat: the route derives company_id/user_id from the JWT and fetches its
// own snapshot.
export const groupService = {
  get(id: string): Promise<GetResult<GroupRow>> {
    return tryGet<GroupRow>(`/api/groups/${encodeURIComponent(id)}`);
  },

  list(_companyId: string): Promise<ListResult<GroupRow>> {
    return tryList<GroupRow>("/api/groups");
  },

  create(
    data: { name: string },
    _context: ServiceContext,
  ): Promise<CreateResult<GroupRow>> {
    return tryCreate<GroupRow>("/api/groups", data);
  },

  update(
    id: string,
    data: Partial<{ name: string; description: string | null; is_active: boolean }>,
    _snapshot: Record<string, unknown>,
    _context: ServiceContext,
  ): Promise<UpdateResult<GroupRow>> {
    return tryUpdate<GroupRow>(`/api/groups/${encodeURIComponent(id)}`, data);
  },

  delete(
    id: string,
    _snapshot: Record<string, unknown>,
    _context: ServiceContext,
  ): Promise<DeleteResult> {
    return tryDelete(`/api/groups/${encodeURIComponent(id)}`);
  },
};
